// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isCustomObjectTypeSchemaDef = objectOf({
  type: string,
  properties: objectOf({}),
  required: maybe(arrayOf(string)),
});

export const isGetCustomObjectsObjectRelationshipTypeSchemaResult = objectOf({
  type_name: string,
  rel_kind: string,
  related_type_name: string,
  schema_def: isCustomObjectTypeSchemaDef,
});
